import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import favorite from './favorite'
import navigation from './navigation'


Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        favorite,
        navigation,
    },
    plugins: [new VuexPersistence({key: 'selfcare'}).plugin]
})
